import React, { useState } from "react";
import { send } from "emailjs-com";
import ScaleLoader from "react-spinners/ScaleLoader";

import "./Contact.css";

function Contact() {
  const [toSend, setToSend] = useState({
    message: "",
    reply_to: "",
  });

  const [message, setMessage] = useState(false);
  const [loading, setLoading] = useState(false);

  const onSubmit = (e) => {
    e.preventDefault();
    if (toSend.message.length < 1 || toSend.reply_to.length < 1) {
      setMessage("Please fill in the form");
      setTimeout(() => {
        setMessage(false);
      }, 2500);
      return null;
    }
    setLoading(true);
    send(
      "service_f6bv5mm",
      "template_sgfojhi",
      toSend,
      "user_uS6eA3jS1bNw409qMXpo6"
    )
      .then((response) => {
        if (response.status === 200) {
          setLoading(false);
          setMessage("Thanks. I will get back to you as soon as possible.");
          setToSend({ message: "", reply_to: "" });
          setTimeout(() => {
            setMessage(false);
          }, 2500);
        }
      })
      .catch(() => {
        setLoading(false);
        setMessage("Something went wrong.");
        setToSend({ message: "", reply_to: "" });
        setTimeout(() => {
          setMessage(false);
        }, 2500);
      });
  };

  const handleChange = (e) => {
    setToSend({ ...toSend, [e.target.name]: e.target.value });
  };
  return (
    <div className="contact-section">
      <div className="contact-title-container">
        <h1 className="section-title">CONTACT</h1>
        <h3 className="section-subtitle">Get in touch with me</h3>
      </div>
      <form onSubmit={onSubmit}>
        <input
          className="text-input"
          type="text"
          name="reply_to"
          placeholder="Your email"
          value={toSend.reply_to}
          onChange={handleChange}
        />
        <textarea
          className="text-input"
          type="text"
          rows={4}
          name="message"
          placeholder="Tell me"
          value={toSend.message}
          onChange={handleChange}
        />
        <div className="button-wrapper">
          <button className="submit-button" type="submit">
            SEND
          </button>
          {!loading ? null : <ScaleLoader />}
          {!message ? null : message}
        </div>
      </form>
    </div>
  );
}

export default Contact;
